<m-card type="custom">
  <section class="two-factor-card">
    <span class="two-factor-card__title" data-testid="two-factor-card-title">{{ title() | mTranslate }}</span>
    <img class="two-factor-card__image" alt="" data-testid="two-factor-card-image" [src]="imageSrc()" />

    <div class="two-factor-card__content" data-testid="two-factor-card-content">
      <ng-content />
    </div>

    <div
      class="two-factor-card__actions"
      data-testid="two-factor-card-actions"
      [class.two-factor-card__actions--between]="actionsPosition() === 'between'"
      [class.two-factor-card__actions--center]="actionsPosition() === 'center'"
      [class.two-factor-card__actions--end]="actionsPosition() === 'end'">
      @for (button of buttons(); track button.text) {
        <button
          m-button
          data-testid="two-factor-card-action-button"
          [buttonType]="button.type ?? 'flat'"
          [color]="button.color ?? 'main'"
          [disabled]="!button.enabled"
          (m-click)="button.onClick()">
          {{ button.text | mTranslate }}
        </button>
      }
    </div>
  </section>
</m-card>
